import { createContext, useContext, type ReactNode } from 'react';
import type { Tracker } from './tracker';

const noop: Tracker = { track() {}, flush() {}, stop() {} };
const Ctx = createContext<Tracker>(noop);

export const TrackerProvider = ({
  tracker,
  children,
}: {
  tracker: Tracker;
  children: ReactNode;
}) => <Ctx.Provider value={tracker}>{children}</Ctx.Provider>;

/** Returns the `track` function. Safe to call anywhere; a no-op without a provider. */
export const useTrack = (): Tracker['track'] => useContext(Ctx).track;
